/** @jsxImportSource @emotion/react */
import { SyncLoader } from 'react-spinners'
import { css } from '@emotion/react'
import { getContrastColor, COLORS } from '@btime/constants'
import React from 'react'

import Counter from '../presentation/Counter'
import fontSizes from '../../utils/constants/fontSizes'

const minWidthSizes = {
  small: 6,
  medium: 8,
  large: 10
}

const Button = ({
  onClick,
  to,
  disabled,
  block,
  medium,
  transparent,
  borderColor,
  fullWidth,
  minWidth,
  minHeight,
  color,
  loading,
  children,
  alertNote,
  small,
  thin,
  href,
  noWrap,
  ...props
}) => {
  transparent = transparent || disabled
  const finalBGColor = transparent || loading ? COLORS.transparent : color || COLORS.purple
  const finalBorderColor = transparent ? borderColor || color : finalBGColor
  const finalColor = transparent ? color : getContrastColor(finalBGColor)

  const style = css`
    border-radius: 5px;
    opacity: ${disabled ? 0.5 : 1};
    color: ${finalColor};
    background: ${finalBGColor};
    border-color: ${finalBorderColor};
    border-width: ${thin ? 1 : 2}px;
    padding: 0.3rem 0.8rem;
    font-size: 0.875rem;
    ${!!small
      ? `
			padding: 0.2rem 0.6rem;
			font-size: ${fontSizes.xsmall}rem;
		`
      : ''}
    font-family: 'Nunito', sans-serif;
    font-weight: 700;
    box-shaddow: none;
    border-style: solid;
    text-decoration: none;
    width: ${fullWidth ? '100%' : 'auto'};
    min-width: ${minWidthSizes[minWidth] || 4}rem;
    ${minHeight ? `min-height: ${minHeight};` : ''}
    ${!!noWrap ? 'white-space: nowrap;' : ''}
    &:hover {
      background: ${finalBGColor}99;
      border-color: ${finalBGColor}99;
    }
  `

  children = !loading ? (
    <Counter alertNote={alertNote}>{children}</Counter>
  ) : (
    <SyncLoader color={COLORS.blue} size={6} />
  )

  const tagProps = {
    type: 'button',
    css: style,
    children: children,
    onClick: loading || disabled ? undefined : onClick,
    ...props
  }
  // eslint-disable-next-line
  if (!!href || to) return <a href={href || to} {...tagProps} />
  return <button type="button" {...tagProps} />
}

export default Button
